
const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 600
};

export const prevArrow = `
    <button class="card-slider__prev ">
        <svg class="prev" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" transform="rotate(90)">
            <path d="M31.946 17.778 22.5 27.225l-9.446-9.447" fill="none" stroke="currentColor" stroke-width="6"/>
        </svg>
    </button>`;
export const nextArrow = `
    <button class="card-slider__next">
        <svg class="next" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" transform="rotate(-90)">
            <path d="M31.946 17.778 22.5 27.225l-9.446-9.447" fill="none" stroke="currentColor" stroke-width="6"/>
        </svg>
    </button>`;


jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--small' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 4,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--medium' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 2,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--large' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 1.33,
            nextArrow,
            prevArrow,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--huge' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 1,
            nextArrow,
            prevArrow,
        } );
    } );
} );